<template>
  <div id="order-paper">

    <div :show.sync="modal"
         :class="{'uk-modal':true,'uk-open':modal}"
         @clickOut="modal = false"
         @inactive="modal = false"
         @keyEsc="modal = false">
      <div class="uk-modal-dialog">
        <div class="uk-modal-body">
          <div class="uk-modal-header">
            <h2>auのメールアドレスをご使用の方</h2>
          </div>
          <div class="uk-modal-body" style="color:black;">
            <p>
              「ezweb.ne.jp」や「au.com」等、auの携帯メールアドレスをご利用のお客様に、注文受付メールが届かないというケースが確認されております。
            </p>
            <p>
              おそらくですが、メールフィルターで、迷惑メールとして判断されてしまうことが原因だと思われます。<br>
              そのため、ご注文の際は「ezweb.ne.jp」「au.com」以外のメールアドレスをご利用いただくか、「info@chapeu.co.jp」「info@chapeu.ciao.jp」からのメールが受信できるよう、受信リスト設定を行ってください。
            </p>
            <p>
              ※携帯のメールアドレスは各社の迷惑メール対策にかかり、注文受付メールが届かないというケースが確認されておりますので、「gmail.com」等のウェブメールのご利用をお勧めします。
            </p>
          </div>
          <div class="uk-modal-footer">
            <vk-button @click="modal = false">閉じる</vk-button>
          </div>
        </div>
      </div>
    </div>

    <div class="order">
      <p>商品の配送先ご住所をご入力ください。</p>
      <p><span class="important">※</span><a href="#" @click="modal=true">auのメールアドレスをご使用の方</a></p>
      <div class="form-group">
        <label for="email">■メールアドレス<span class="important">※</span></label>
        <input id="email" type="text" v-model="email" @focus="inputFocus" @blur="inputBlur">
        <p>
          ※携帯のメールアドレスは各社の迷惑メール対策にかかり、注文受付メールが届かないというケースが確認されておりますので、
          「gmail.com」等のウェブメールのご利用をお勧めします。
        </p>
      </div>
      <div class="form-group">
        <label for="email-confirm">■メールアドレス（確認用）<span class="important">※</span></label>
        <input id="email-confirm" type="text" v-model="email_confirm" @focus="inputFocus" @blur="inputBlur">
      </div>
      <div class="form-group">
        <label for="name">■お名前<span class="important">※</span></label>
        <input id="name" type="text" v-model="name" @focus="inputFocus" @blur="inputBlur">
      </div>
      <div class="form-group">
        <label for="zip">■郵便番号<span class="important">※</span></label>
        <zip-input id="edit_zip"  maxlength="8" size="8" placeholder="000-0000" v-model="zip" @blur="inputBlur">></zip-input>
        <button id="btnUpdateAddress" @click="updateAddress">住所に反映</button>
      </div>
      <div class="form-group">
        <label for="city">■ご住所<span class="important">※</span></label>
        <input id="city" type="text" v-model="address" @focus="inputFocus" @blur="inputBlur">
        <input id="street" type="text" v-model="street" placeholder="番地" @focus="inputFocus" @blur="inputBlur">
      </div>
      <div class="form-group">
        <label for="tel">■電話番号<span class="important">※</span></label>
        <phone-input v-model="tel"></phone-input>
      </div>
      <div class="form-group">
        <div>■決済方法選択</div>
        <fieldset class="payment_method-field">
          <div>
            <label><input class="uk-radio" name="payment_method" type="radio" value="credit" v-model="payment_method">
              クレジットカード決済（推奨）
            </label>
            <div>※一般的なオーダーの方は、こちらを選択してください。</div>
          </div>
          <div>
            <label><input class="uk-radio" name="payment_method" type="radio" value="bank" v-model="payment_method">
              銀行振込
            </label>
            <div>※エンブレムを入れたい等の、シミュレーターでは出来ないアレンジをご希望の方は、必ずこちらを選択してください。<br>
              また、ジャージやピステ等、シミュレーターに掲載されていない商品と一緒にご購入される方も、必ずこちらを選択してください。</div>
          </div>
        </fieldset>
      </div>
      <div class="form-group">
        <label for="comment"> ■備考（任意）</label>
        <div class="annotation">
          ※背番号の指定などがあればご記載ください」から、「エンブレムを入れたい等の、アレンジをご希望の際は、こちらに記載ください。
        </div>
        <textarea id="comment" v-model="comment" @focus="inputFocus" @blur="inputBlur"></textarea>
      </div>

      <div class="form-group rule">
        <label> ■ご利用規約</label>
        <textarea disabled="disabled" rows="5">
「利用規約」

この利用規約（以下、「本規約」といいます。）は、株式会社 Chapeu（以下、「当社」といいます。）がこのウェブサイト上で提供するChapeuシミュレーター（以下、「本サービス」といいます。）の利用条件を定めるものです。
お客様の皆さま（以下、「お客様」といいます。）には、本規約に従って、本サービスをご利用いただきます。

第1条（適用）
* 本規約は、お客様と当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
* 当社は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下,「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
* 本規約の定めが前項の個別規定の定めと矛盾する場合には、個別規定において特段の定めなき限り、個別規定の定めが優先されるものとします。

第2条（売買契約）
* 本サービスにおいては、お客様が当社に対して購入の申し込みをし、これに対して当社が当該申し込みを承諾した旨の通知をすることによって売買契約が成立するものとします。なお、当該商品の所有権は、当社が商品を配送業者に引き渡したときに、お客様に移転するものとします。
* 当社は、お客様が以下のいずれかの事由に該当する場合には、当該お客様に事前に通知することなく、前項の売買契約を解除することができるものとします。
    * お客様が本規約に違反した場合
    * 届け先不明や長期の不在のため商品の配送が完了しない場合
    * その他当社とお客様の信頼関係が損なわれたと認める場合
* 本サービスに関する決済方法、配送方法、別途当社が定める方法によります。
* 売買契約成立後のキャンセルはできません。また「イメージと違う」「サイズが合わない」等の、クレーム・返品も受け付けられません。
* お使いのモニターによってはウエアやプリントのカラーが実際の色と多少異なる場合があります。
* １回の注文でロゴ・ドット共に３色以上の色替えがある場合、３色目以降１色につき通常価格に１００円ずつプラスとなります。なお、ウエアの色・サイズが変わることに関しては金額はアップありません。

第３条（製作期間）
出来上がりはデザイン決定後、約１ヶ月～１ヶ月半程度の期間をいただきます。工場の状況によって納期期間は前後致しますので、何卒ご了承ください。
急な納期には対応できない場合があります。

第４条（知的財産権）
本サービスによって提供される商品写真その他のコンテンツ（以下「コンテンツ」といいます）の著作権又はその他の知的所有権は,当社及びコンテンツ提供者などの正当な権利者に帰属し,お客様は,これらを無断で複製,転載,改変,その他の二次利用をすることはできません。

第５条（禁止事項）
お客様は、本サービスの利用にあたり、以下の行為をしてはならないものとします。
* 法令または公序良俗に違反する行為
* 犯罪行為に関連する行為
* 本サービスに含まれる著作権、商標権その他の知的財産権を侵害する行為
* 当社のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
* 本サービスによって得られた情報を商業的に利用する行為
* 当社のサービスの運営を妨害するおそれのある行為
* 不正アクセスをし、またはこれを試みる行為
* 他のお客様に関する個人情報等を収集または蓄積する行為
* 他のお客様に成りすます行為
* 当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
* その他、当社が不適切と判断する行為

第６条（本サービスの提供の停止等）
* 当社は、以下のいずれかの事由があると判断した場合、お客様に事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
    * 本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
    * 地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
    * コンピュータまたは通信回線等が事故により停止した場合
    * その他、当社が本サービスの提供が困難と判断した場合
* 当社は、本サービスの提供の停止または中断により、お客様または第三者が被ったいかなる不利益または損害について、理由を問わず一切の責任を負わないものとします。

第７条（利用制限および登録抹消）
* 当社は、以下のいずれかに該当する場合には、事前の通知なく、お客様に対して、本サービスの全部もしくは一部の利用を制限できるものとします。
    * 本規約のいずれかの条項に違反した場合
    * 登録事項に虚偽の事実があることが判明した場合
    * 料金等の支払債務の不履行があった場合
    * 当社からの連絡に対し、一定期間返答がない場合
    * その他、当社が本サービスの利用を適当でないと判断した場合
* 当社は、本条に基づき当社が行った行為によりお客様に生じた損害について、一切の責任を負いません。


第８条（保証の否認および免責事項）
* 当社は,本サービスに事実上または法律上の瑕疵（安全性,信頼性,正確性,完全性,有効性,特定の目的への適合性,セキュリティなどに関する欠陥,エラーやバグ,権利侵害などを含みます。）がないことを保証するものではありません。
* 当社は,本サービスによってお客様に生じたあらゆる損害について,一切の責任を負いません。ただし,本サービスに関する当社とお客様との間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合,この免責規定は適用されませんが,この場合であっても,当社は,当社の過失（重過失を除きます。）による債務不履行または不法行為によりお客様に生じた損害のうち特別な事情から生じた損害（当社またはお客様が損害発生につき予見し,または予見し得た場合を含みます。）について一切の責任を負いません。
* 当社は、本サービスに関して、お客様と他のお客様または第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。

第９条（サービス内容の変更等）
当社は、お客様に通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってお客様に生じた損害について一切の責任を負いません。

第１０条（利用規約の変更）
当社は、必要と判断した場合には、お客様に通知することなくいつでも本規約を変更することができるものとします。なお、本規約の変更後、本サービスの利用を開始した場合には、当該お客様は変更後の規約に同意したものとみなします。

第１１条（個人情報の取扱い）
当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。

第１２条（通知または連絡）
お客様と当社との間の通知または連絡は、当社の定める方法によって行うものとします。提出されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い,これらは,発信時にお客様へ到達したものとみなします。

第１３条（権利義務の譲渡の禁止）
お客様は、当社の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。

第１４条（準拠法・裁判管轄）
* 本規約の解釈にあたっては、日本法を準拠法とします。なお、本サービスに関しては、国際物品売買契約に関する国際連合条約の適用を排除するものとします。
* 本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。
        </textarea>
        <p class="notice">確認に進む場合は上記「ご利用規約」に同意の上【ご利用規約に同意します】をチェックしてください。</p>
        <label class="rule__accept">
          <input type="checkbox" v-model="acceptRule">
          ご利用規約に同意します。
        </label>
      </div>
    </div>

    <div class="footer">
      <div class="footer-container">
        <vk-button @click="$router.back()">戻る</vk-button>
        <vk-button @click="next" :disabled="!allowNext" :class="{disabled:!allowNext}">確認</vk-button>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import axios from 'axios'
  import PhoneInput from './phone-input'
  import ZipInput from './zip-input'

  export default {
    name: 'input-paper',
    components: {PhoneInput, ZipInput},
    data(){
      return {
        email: (this.order && this.order.email) ? this.order.email : null,
        email_confirm: (this.order && this.order.email_confirm) ? this.order.email_confirm : null,
        name: (this.order && this.order.name) ? this.order.name : null,
        zip: (this.order && this.order.zip) ? this.order.zip : null,
        address: (this.order && this.order.address) ? this.order.address : null,
        street: (this.order && this.order.street) ? this.order.street : null,
        tel: (this.order && this.order.tel) ? this.order.tel : null,
        payment_method: 'credit',
        comment: (this.order && this.order.comment) ? this.order.comment : null,
        acceptRule: false,
        modal: false,
      }
    },
    computed: {
      ...mapState(['cart']),
      ...mapGetters(['order']),
      allowNext: function(){
        if (
          (this.email && this.email == this.email_confirm) &&
          this.name &&
          this.zip &&
          this.address &&
          this.street &&
          this.tel &&
          this.acceptRule
        ) {
          return true
        } else {
          return false;
        }
      }
    },
    created () {
      if (this.order) {
        this.input = this.order;
        this.email = this.order.email;
        this.email_confirm = this.order.email_confirm;
        this.name = this.order.name;
        this.zip = this.order.zip;
        this.address = this.order.address;
        this.street = this.order.street;
        this.tel = this.order.tel;
        this.comment = this.order.comment;
      }
    },
    methods: {
      ...mapMutations([
        'setOrder',
      ]),
      next(){
        if (!this.allowNext) return;
        this.$store.commit('setOrder', {
          email: this.email,
          email_confirm: this.email_confirm,
          name: this.name,
          zip: this.zip,
          address: this.address,
          street: this.street,
          tel: this.tel,
          payment_method: this.payment_method,
          comment: this.comment,
        });
        this.$router.push({name:'orderConfirm'});
      },
      async updateAddress () {
        axios.defaults.withCredentials = true;
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const res = await axios.get('https://apis.postcode-jp.com/api/v3/postcodes', {
          params: {
            apikey: 'M6brS5oVR6hqmSFOeGkHerxJOjNksH0CHxQ4td0',
            postcode: this.zip.replace('-', ''),
          },
        });
        let res_data = res.data.data[0];
        this.address = res_data.allAddress;
      },
      inputFocus () {
        let ua = navigator.userAgent.toLowerCase();
        let isiPhone = (ua.indexOf('iphone') > -1);
        let isiPad = (ua.indexOf('ipad') > -1);
        if (isiPhone || isiPad) {
          document.querySelectorAll('.position-fixed').forEach(element => {
            element.style.position = 'absolute';
          })
        }
      },
      inputBlur () {
        let ua = navigator.userAgent.toLowerCase();
        let isiPhone = (ua.indexOf('iphone') > -1);
        let isiPad = (ua.indexOf('ipad') > -1);
        if (isiPhone || isiPad) {
          this.$nextTick(() => {
            document.querySelectorAll('.position-fixed').forEach(element => {
              element.style.position = 'fixed';
            })
          })
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .product {
    padding: 10px;
  }

  .product .size {
  }

  .product .value {
    width: 3rem;
  }

  .add_card {
    background-color: #9cc;
    width: 100%;
  }

  .footer {
    color: #fff;
    background-color: #151d66;
    position: fixed;
    width: 100%;
    bottom: 0;
    color: #fff;
    background-color: #151d66;
    .footer-container {
      display: flex;
      padding: 5px;
      height: 36px;
      button {
        flex-grow: 1;
        margin: 0 4px;
      }
    }
  }
  .footer button.disabled{
    background-color: rgb(54,62,110);
  }

  .important{
    color:red;
  }
  .annotation{
    margin: 4px 0;
    line-height: 1.3em;
    font-size:small;
  }
  .form-group label {
    margin-bottom: 4px;
  }
  #order-paper .order{
    padding: 5px;
    padding-bottom: 4rem;
  }
  #order-paper .order .form-group{
    margin-bottom: 1rem;
  }
  #order-paper .order label{
    display: block;
  }

  input,textarea {
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
  }
  #zip {
    width: 9em;
  }
  .rule {
    textarea {
      font-size: medium;
      font-size: small;
      color: #000000;
      border: 1px solid black;
    }
    .notice {
      color: #1e87f0;
      font-size: small;
      margin: 0;
    }
    .rule__accept {
      margin: 0;
      text-align: right;
      input {
        margin: 0;
        width: initial;
      }
    }
  }
  .payment_method-field {
    margin: 0;
    & > div {
      margin-top: 1rem;
      & > div {
        margin-top: .4rem;
        font-size: small;
      }
    }
    .uk-radio {
      width: 1.2rem;
      margin-right: .5rem;
    }
  }


  .uk-modal.uk-open{
    display:block;
    h2 { font-size: 16px; }
    .uk-modal-body {
      margin: 0;
      padding: 10px;
      p {
        line-height: 1.2rem;
      }
    }
    .uk-modal-footer {
      button {
        border: 1px solid #fff;
        border-radius: 4px;
        background-color: rgb(54,62,110);
        color: #fff;
        outline: 0;
        vertical-align: middle;
        cursor: pointer;
        text-align: center;
        display: inline-block;
        height: 35px;
        margin: 4px;
      }
    }
  }
</style>
